if (!customElements.get("hoculus-video-slide")) {
    class HoculusVideoSlide extends HTMLElement {
        constructor () {
            super();
        }

        connectedCallback () {
            this.videoCont = this.querySelector(".video-div");

            this.videoType = this.videoCont?.dataset.type;
            this.videoId = this.videoCont?.dataset.videoId;
            this.blockId = this.dataset.blockId;
            this.videoLoop = this.dataset.videoLoop;
            this.player = null;

            if (this.videoCont && window.theme) {
                this.videoCont.dataset.videoLoop = this.videoLoop;

                window.theme.initWhenVisible({
                    element: this,
                    callback: this.initVideo.bind(this),
                    threshold: 500
                });

                this.classList.add("hoc-video-slide--" + this.blockId);
            }
        }

        disconnectedCallback () {
            if (this.player && typeof this.player.destroy === "function") {
                this.player.destroy();
            }
        }

        initVideo () {
            switch (this.videoType) {
                case "youtube":
                    this.player = new window.theme.YouTube(this.videoCont.id, {
                        videoId: this.videoId,
                        videoParent: ".hoc-video-slide--" + this.blockId,
                        loop: this.videoLoop
                    });
                    break;
                
                case "vimeo":
                    this.player = new window.theme.VimeoPlayer(this.videoCont.id, this.videoId, {
                        videoParent: ".hoc-video-slide--" + this.blockId,
                        loop: this.videoLoop
                    });
                    break;
                
                default:
                    if (this.videoCont instanceof HTMLVideoElement) {
                        this.initMp4Video();
                    }
                    break;
            }
        }

        initMp4Video () {
            const playPromise = this.querySelector("video")?.play();

            playPromise?.catch(() => {
                this.videoCont.setAttribute("controls", "");
                this.classList.add("video-interactable");
            });
            
            this.classList.add("loaded");
        }
    }

    customElements.define("hoculus-video-slide", HoculusVideoSlide);
}